<template>
  <Form ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="100">
    <FormItem label="用户ID"
              prop="userId">
      <Input v-model="formValidate.userId"
             placeholder="直接输入用户ID，离开编辑框自动获取用户信息"
             @on-blur="getInfoByUserId" />
    </FormItem>
    <FormItem label="真实姓名"
              prop="userName">
      <Input v-model="formValidate.userName"
             placeholder="请输入真实姓名" />
    </FormItem>

    <FormItem label="密码"
              prop="password">
      <Input v-model="formValidate.password"
             placeholder="请输入初始密码"
             type="password" />
    </FormItem>
    <FormItem label="手机号"
              prop="phone">
      <Input v-model="formValidate.phone"
             placeholder="请输入职员的手机号码" />
    </FormItem>

    <FormItem label="权限"
              prop="lv">
      <RadioGroup v-model="formValidate.lv">
        <Radio label="1">普通用户</Radio>
        <Radio label="9">管理员</Radio>
      </RadioGroup>
    </FormItem>

    <FormItem label="性别"
              prop="gender">
      <RadioGroup v-model="formValidate.gender">
        <Radio label="male">男</Radio>
        <Radio label="female">女</Radio>
      </RadioGroup>
    </FormItem>

    <FormItem label="状态"
              prop="state">
      <RadioGroup v-model="formValidate.state">
        <Radio label="1">激活</Radio>
        <Radio label="0">禁止</Radio>
      </RadioGroup>
    </FormItem>

    <FormItem>
      <Button type="primary"
              @click="handleSubmit('formValidate')">更新信息</Button>
      <Button @click="handleReset('formValidate')"
              style="margin-left: 8px">重设</Button>
    </FormItem>
  </Form>
</template>
<script>
export default {
  name: 'usereidt',
  data () {
    return {
      formValidate: {
        id: '',
        userId: '',
        userName: '',
        password: '',
        phone: '',
        gender: '',
        state: '1',
        lv: ''
      },
      ruleValidate: {
        userId: [
          {
            required: true,
            message: '用户ID不能为空',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  mounted () {
    let params = this.$route.params;
    if (params.id) {
      this.getInfoById(params.id);
    }
    if (params.token) {
      this.getInfoByToken(params.token);
    }
  },
  computed: {
    formData () {
      let data = {
        id: this.formValidate.id,
        userId: this.formValidate.userId,
        password: this.formValidate.password,
        userName: this.formValidate.userName,
        phone: this.formValidate.phone,
        gender: this.formValidate.gender,
        state: this.formValidate.state,
        lv: Number(this.formValidate.lv)
      };
      return data;
    }
  },
  methods: {
    getInfoByUserId () {
      // 请求后台获取用户信息：
      // console.log(name.srcElement.value);

      this.$refs['formValidate'].validate(valid => {
        console.log('valid', valid);
        if (valid) {
          let _this = this;
          this.$axios
            .request({
              url:
                'caiji/?s=user.getUserInfo&userId=' + this.formValidate.userId,
              method: 'GET'
            })
            .then(json => {
              console.log(json);
              let jsonData = json.data;
              if (jsonData.ret === 200) {
                _this.formValidate = jsonData.data;
              } else {
                _this.$Message.error(jsonData.msg);
              }
            });
        }
      });
    },
    getInfoById (ID) {
      console.log('ID', ID);
      if (ID) {
        let _this = this;
        this.$axios
          .request({
            url: 'caiji/?s=user.getUserInfo&id=' + ID,
            method: 'GET'
          })
          .then(json => {
            console.log('getInfoById', json);
            let jsonData = json.data;
            if (jsonData.ret === 200) {
              _this.formValidate = jsonData.data;
            } else {
              _this.$Message.error(jsonData.msg);
            }
          });
      }
    },
    getInfoByToken (token) {
      if (token) {
        let _this = this;
        this.$axios
          .request({
            url: 'caiji/?s=user.getUserInfo&token=' + token,
            method: 'GET'
          })
          .then(json => {
            console.log('getInfoByToken', json);
            let jsonData = json.data;
            if (jsonData.ret === 200) {
              _this.formValidate = jsonData.data;
            } else {
              _this.$Message.error(jsonData.msg);
            }
          });
      }
    },
    handleSubmit (name) {
      console.log(this.formData);
      let _this = this;
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$axios
            .request({
              url: 'caiji/?s=user.edit',
              data: _this.formData,
              method: 'POST'
            })
            .then(json => {
              console.log('handleSubmit', json);
              let jsonData = json.data;
              if (jsonData.ret === 200) {
                _this.$Message.success('用户信息修改成功!');
              } else {
                _this.$Message.error(jsonData.msg);
              }
            });
        } else {
          this.$Message.error('Fail!');
        }
      });
    }
  }
};
</script>
